import { env } from "configs/EnvironmentConfig";
import fetchV2 from "auth/FetchInterceptorV2";

const routeLocalitiesService = {};

routeLocalitiesService.getRouteLocalities = (params) => {
    return fetchV2({
        url: `${env.API_MSP}/route-localities`,
        method: "get",
        params: {
            ...params,
            "filter[record_status]": "O",
        },
    });
};

export default routeLocalitiesService;
